import { EventIndexEntriesQueryVariables } from '@/__generated__/graphql';
import { toEventTimeOrder } from '../utils/toEventTimeOrder';
import { useEvents } from './useEvents';

export const useEventIndexEntries = (variables: EventIndexEntriesQueryVariables) => {
  const { items, loading, error } = useEvents(variables);

  // No access to eventTime within GraphQL query/variables
  const sortedItems = toEventTimeOrder(items);

  return {
    sortedItems,
    loading,
    error,
  };
};
